import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import './index.css';
import App from './App';
import OrgProvider from './OrgContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <OrgProvider>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </OrgProvider>
);

